import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class SalesService {

    public Lablocationdata: any;

    constructor(private httpService: HttpService) { }


    // ============lablocation================

    getLablocationByclientId(id: any) {
        const url = `${environment.SalesApiendpoint}/lablocationListByClient/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getallLablocation() {
        const url = `${environment.SalesApiendpoint}/get-lablocation/`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    };

    obtainLablocations(page:any){
        const url = `${environment.SalesApiendpoint}/SalesReport?${page}`;
        return this.httpService.get(url,this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getSalesRep() {
        // Chandan
      const url = `${environment.SalesApiendpoint}/salereplisting`;
      return this.httpService.get(url, this.httpService.headers)
          .pipe(
              catchError(this.Errorhandling)
          );
    }


  getSalesCenter() {
    //
  const url = `${environment.SalesApiendpoint}/saleCenterlist`;
  return this.httpService.get(url, this.httpService.headers)
      .pipe(
          catchError(this.Errorhandling)
      );
}

  getallClientForDropdown() {
    const url = `${environment.SalesApiendpoint}/clientListing`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}
  getProspect() {
  const url = `${environment.SalesApiendpoint}/prospectlistFordropdown`;
  return this.httpService.get(url, this.httpService.headers)
      .pipe(
          catchError(this.Errorhandling)
      );
}
  getClients(user: any) {
    const url = `${environment.SalesApiendpoint}/clientList?${user}`;
    return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
}

    addTeam(data: any): Observable<any> {
        const url = `${environment.SalesApiendpoint }/addTeam`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    addComplain(data: any): Observable<any> {
        const url = `${environment.SalesApiendpoint }/addComplaints`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    addProspect(data: any): Observable<any> {
        const url = `${environment.SalesApiendpoint }/addProspect`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    getallTeamandId() {
        const url = `${environment.SalesApiendpoint}/teamList`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }







  assignRep(data: any, id: any): Observable<any> {
    const url = `${environment.SalesApiendpoint}/reassignSalerep/${id}`
    return this.httpService.put(url, data, this.httpService.headers)
  }

  salesRepProfileUpload(data:any, id: any): Observable<any> {
    const url = `${environment.SalesApiendpoint}/salerepprofilepic/${id}`
    return this.httpService.post(url, data, this.httpService.headers)
}

    deleteTeams(id: any) {
        const url = `${environment.SalesApiendpoint}/deleteTeam/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    editTeam(user: any) {
        const url = `${environment.SalesApiendpoint}/teamListbyId/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    // -------------------Appointment---------------------

    appointmentList(data: any) {
        const url = `${environment.SalesApiendpoint}/appointmentListing?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    addAppointment(data: any): Observable<any> {
        const url = `${environment.SalesApiendpoint }/addAppointmentforWeb`
        return this.httpService.post(url, data, this.httpService.headers)
    }

    cancelAppointment(data: any,id:number): Observable<any> {
        const url = `${environment.SalesApiendpoint }/createappointmenttimeline/${id}`
        return this.httpService.post(url, data, this.httpService.headers)
    }


    getAppointmentbyIddata(salerep_id: number) {
        const url = `${environment.SalesApiendpoint}/salerepdetails/${salerep_id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

// --------------Sales/repersantive--------------------------
    obtainPhlebo(user: any) {
        const url = `${environment.SettingsApiendpoint}/phlebos/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallSalesReps(data:any) {
        const url = `${environment.SalesApiendpoint}/salerepList?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    getallSalesTarget(data:any) {
        const url = `${environment.SalesApiendpoint}/ViewTarget?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    addMastertarget(data:any) {
        const url = `${environment.SalesApiendpoint}/addMastertarget`;
        return this.httpService.post(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    addSaleRepTarget(data:any) {
        const url = `${environment.SalesApiendpoint}/addsalereptarget`;
        return this.httpService.post(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    addSalesTarget(data:any){
        const url = `${environment.SalesApiendpoint}/addSalesTarget`;
        return this.httpService.post(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getOneSalesTarget(id:any) {
        const url = `${environment.SalesApiendpoint}/viewmonthlyTarget/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateSalesTarget(data:any, id:any) {
        const url = `${environment.SalesApiendpoint}/editmonthlyTarget/${id}`;
        return this.httpService.put(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getSalesDropdown() {
        const url = `${environment.SalesApiendpoint}/saleRep_dropdown`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    salesMaster(year:any) {
        const url = `${environment.SalesApiendpoint}/viewMastertarget?year=${year}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    saleRepTarget(year:any, id:any) {
        const url = `${environment.SalesApiendpoint}/viewsalereptarget?year=${year}&salerep_id=${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


  //  =============================selsRepresentative======================
    addsalse(data: any): Observable<any> {
        const url = `${environment.SalesApiendpoint}/addsaleRep`
        return this.httpService.post(url, data, this.httpService.headers)
    }

    getReps(user: any) {
        const url = `${environment.SalesApiendpoint}/salerepListbyId/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    UpdateSaleReps(data: any, salsReps: any): Observable<any> {
        const url = `${environment.SalesApiendpoint}/updateSalerep/${salsReps}`
        return this.httpService.put(url, data, this.httpService.headers)
    }

    deleteSalse(id: any) {
        const url = `${environment.SalesApiendpoint}/deleteSalerep/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    // ===========sales Prospect=============================


    uploadProspectFile(data:any, imagefile: File) {
        const url = `${environment.SalesApiendpoint}/prospect_import`;
        const formData = new FormData();

        formData.append('file', imagefile);
            formData.append('customer_id',data.customer_id);
            formData.append('provider_id',data.provider_id);

        return this.httpService
            .post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }

    getProspectTimeline(id: number) {
        const url = `${environment.SalesApiendpoint}/prospectstatusTimeline/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }

    designationlist() {

        const url = `${environment.SalesApiendpoint}/designationListing`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    prospectFccorDropdown() {

        const url = `${environment.SalesApiendpoint}/prospectlistFordropdown`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    addNotesForAppointment(data: any,id:any) {
        const url = `${environment.SalesApiendpoint}/addNotes_appointment/${id}`;
        return this.httpService.post(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    addNotes(data: any,id:any) {
        const url = `${environment.SalesApiendpoint}/addNotes/${id}`;
        return this.httpService.post(url,data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    getProspectDetails(id:any) {

        const url = `${environment.SalesApiendpoint}/detail-prospect/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getProspectNotes(id:any) {
        const url = `${environment.SalesApiendpoint}/clientNotes/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getAppointmentNotes(id:any) {
        const url = `${environment.SalesApiendpoint}/clientNotesforappointment/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getComplainNotes(id:any) {
        const url = `${environment.SalesApiendpoint}/viewNotes/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    UpdateProspect(data: any, id: any): Observable<any> {
        const url = `${environment.SalesApiendpoint}/updateProspect/${id}`
        return this.httpService.put(url, data, this.httpService.headers)
    }

    DownloadProspect(){
        const url = `${environment.SalesApiendpoint}/prospect_export`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    DownloadClient(){
        const url = `${environment.SalesApiendpoint}/client_export`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    DownloadSalesRep(data){
        const url = `${environment.SalesApiendpoint}/salerep_export?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    DownloadReport(data){
        const url = `${environment.SalesApiendpoint}/exportSaleReport?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    addStatus(data: any,client:any): Observable<any> {
      const url = `${environment.SalesApiendpoint}/addStatus/${client}`
      return this.httpService.post(url, data, this.httpService.headers)
  }

  addComplainStatus(data: any,id:any): Observable<any> {
    const url = `${environment.SalesApiendpoint}/updateStatus/${id}`
    return this.httpService.put(url, data, this.httpService.headers)
}

assignTeam(data: any,id:any): Observable<any> {
    const url = `${environment.SalesApiendpoint}/assignTeam/${id}`
    return this.httpService.post(url, data, this.httpService.headers)
}


    obtainLablocation(user: any) {
        const url = `${environment.SalesApiendpoint}/updateTeam/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    editprospect(data: any, Lablocation: any): Observable<any> {
        const url = `${environment.SalesApiendpoint}/update_lab_location/${Lablocation}`
        return this.httpService.put(url, data, this.httpService.headers)
    }

    UpdateTeam(data: any, Lablocation: any): Observable<any> {
        const url = `${environment.SalesApiendpoint}/updateTeam/${Lablocation}`
        return this.httpService.put(url, data, this.httpService.headers)
    }

    updateStatus(id: any, status: any): Observable<any> {



        let data ;
        if (status == 'Active') {
            data = {
                status: 'Inactive'
            };
        }else{
            data = {
                status: 'Active'
            };
        }
        const url = `${environment.SalesApiendpoint}/Lablocation-change-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    obtainTeams(search: any) {
          const url = `${environment.SalesApiendpoint}/teamList?${search}`;
          return this.httpService.get(url, this.httpService.headers)
              .pipe(
                  catchError(this.Errorhandling)
              );
      }
      obtainComplain(search: any) {
          const url = `${environment.SalesApiendpoint}/viewComplaints?${search}`;
          return this.httpService.get(url, this.httpService.headers)
              .pipe(
                  catchError(this.Errorhandling)
              );
      }

    salesrepslistteam() {
          const url = `${environment.SalesApiendpoint}/teamList`;
          return this.httpService.get(url, this.httpService.headers)
              .pipe(
                  catchError(this.Errorhandling)
              );
      }

      salesrepsSummary(data:any) {
        const url = `${environment.SalesApiendpoint}/salerepReport?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    prospectList(search: any) {
        const url = `${environment.SalesApiendpoint}/prospectList?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getAllCityById(id: any) {
        const url = `${environment.SalesApiendpoint}/cities-by-state-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    status() {
      const url = `${environment.SalesApiendpoint}/masterStatus`;
      return this.httpService.get(url, this.httpService.headers)
          .pipe(
              catchError(this.Errorhandling)
          );
      }

    getAllCity() {
        const url = `${environment.SalesApiendpoint}/cities?d=all`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllTeam() {
        const url = `${environment.SalesApiendpoint}/teamnameList`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllAreacodeById(id: any) {
        const url = `${environment.SalesApiendpoint}/area-codes-by-city-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    // createLablocation(data: any): Observable<any> {
    //   const url = `${environment.SalesApiendpoint}/Lablocations`;
    //   return this.httpService.post(url, data, this.httpService.headers);
    // }

    getLablocation(data: any): Observable<any> {
        this.Lablocationdata = [
            {
                id: '1',
                emp_code: '123',
                first_name: 'Abhishek',
                last_name: 'Anand',
                email: 'temp@email.com',
                phone: '25012021',
                status: 'Active',
                city: 'Dehradun',
                state: 'Uttarakhand',
            },
        ];

        return this.Lablocationdata;
    }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
